import * as React from "react";

export default function Body({ children }) {
  return (
    <div
      style={{
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {children}
    </div>
  );
}
